<template>
  <ul class="legal-navigation">
    <li class="legal-navigation__item">
      <a
        :href="pageData.urls.homePrivacy"
        class="legal-navigation__link"
      >
        {{ pageData.resourceStrings.privacyPolicy }}
      </a>
    </li>
    <li class="legal-navigation__item">
      <a
        :href="pageData.urls.homeTermsOfUse"
        class="legal-navigation__link"
      >
        {{ pageData.resourceStrings.termsOfUse }}
      </a>
    </li>
    <li class="legal-navigation__item">
      <a
        :href="pageData.urls.homeDoNotSellMyInformation"
        class="legal-navigation__link"
      >
        {{ pageData.resourceStrings.doNotSellMyInformation }}
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'LegalNavigation',
  props: {
    pageData: { type: Object, default: null, required: true }
  }
}
</script>

<style lang="scss" scoped>
.legal-navigation {
  margin: 0 0 20px 0;
  padding: 0 0 10px 0;
  border-bottom: 1px solid #d8dbde;

  @media screen and (min-width: $screen-md-min) {
    text-align: center;
    padding: 0;
    border-bottom: none;
  }

  &__item {
    font-family: $font-circular-std;
    font-size: 0.9rem;
    font-weight: 800;
    list-style: none;
    margin: 0 0 10px 0;

    @media screen and (min-width: $screen-md-min) {
      display: inline-block;
      margin: 0;
      padding: 0 4px;
    }
  }

  &__link {
    color: #535353;
    font-weight: normal;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WebResources/vue/grad-images/site-footer/components/LegalNavigation.vue